import React from "react";
import { Col, Form, notification, Row } from "antd";
import s from "./ActivateAccount.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { resendOtp, verifyEmail } from "../../redux/AuthSlice";
import { CheckCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { useTranslation } from "react-i18next";
import LoginHeader from "../../components/Header/LoginHeader";
import Header from "../../components/Header/Header";
import { getManagerEmployeesList } from "../../redux/UserSlice";
import { toast, ToastContainer } from "react-toastify";

const ActivateAccount = () => {
  const [form] = useForm();
  const email = useSelector((state: RootState) => state.auth.email);
  const employeeEmail = useSelector(
    (state: RootState) => state.auth.employeeEmail
  );

  const dispatch: AppDispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const role = useSelector((state: RootState) => state.auth.role);

  const openNotification =
    (pauseOnHover: boolean, title: string, type: "success" | "error") => () => {
      let icon;
      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message: title,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };

  const sendOtp = async (values: { otp: string }) => {
    if (email) {
      const res = await dispatch(
        verifyEmail({
          email,
          otp: values.otp,
        })
      );

      if (res.type === "auth/verifyEmail/fulfilled") {
        const message =
          res.payload && "message" in res.payload ? res.payload.message : "";

        openNotification(true, message, "success")();

        setTimeout(() => {
          navigate("/login");
        }, 5000);
      }
      if (res.type === "auth/verifyEmail/rejected") {
        const errorMessage =
          res.payload && "error" in res.payload
            ? res.payload.error
            : "Произошла ошибка";

        openNotification(true, errorMessage, "error")();
      }
    }
  };

  const sendNewOtp = async () => {
    if (email) {
      const res = await dispatch(resendOtp({ email }));

      console.log("res", res);

      if (res.type === "auth/resendOtp/fulfilled") {
        toast.success("Новый ОТП код отправлен на ваш email");
      }
    }
  };

  return (
    <div>
      <ToastContainer />
      {role === "regional_manager" ? <Header /> : <LoginHeader />}
      <div className={s.activate_account}>
        {contextHolder}
        <div className={s.title}>
          {" "}
          <CheckCircleOutlined className={s.icon} /> {t("Активировать профиль")}
        </div>
        <div className={s.subtitle}>
          {t("Укажите OTP код отправленный вам на почту")}
        </div>
        <Form
          className={s.form}
          layout="vertical"
          form={form}
          onFinish={sendOtp}
        >
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name="otp"
                label={t("OTP код")}
                rules={[
                  {
                    required: true,
                    message: t("Укажите OTP код"),
                  },
                  {
                    len: 6,
                    message: t("OTP код должен содержать ровно 6 символов"),
                  },
                  {
                    pattern: /^\d{6}$/, // Ensures only digits
                    message: t("OTP код должен содержать только цифры"),
                  },
                ]}
              >
                <input className={s.input} placeholder={t("Укажите OTP код")} />
              </Form.Item>
              <div className={s.resend_otp} onClick={() => sendNewOtp()}>
                {t("Запросить новый OTP код")}
              </div>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <button className={s.btn}>{t("Отправить")}</button>
            </Col>
          </Row>
          {role !== "regional_manager" && (
            <Row gutter={24}>
              <Col span={24}>
                <div className={s.register_btn}>
                  {t("Нет аккаунта?")}{" "}
                  <Link to="/register" className={s.link}>
                    {t("Зарегистрироваться")}
                  </Link>
                </div>
              </Col>
            </Row>
          )}
        </Form>
      </div>
    </div>
  );
};

export default ActivateAccount;
